<button (click)="globals.login=false; router.navigate(['home'])">Logout</button>
<table *ngIf="liften">
    <tr *ngFor="let lift of liften">
        <td class="link" (click)="goto(lift.ID)">{{lift.ID}}</td>
        <td>{{lift.Omschr}}</td>
        <td>{{lift.Adres}}</td>
    </tr>
</table>
